class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    /* On mobile, opening the modal causes layout shift and the virtual
       keyboard opening triggers scroll/resize events on window. FastSimon
       AC listens on window scroll/resize to close the dropdown. We suppress
       these events briefly so the AC stays open after programmatic focus. */
    var container = this.detailsContainer.querySelector('[tabindex="-1"]');
    var input = this.detailsContainer.querySelector('input:not([type="hidden"])');

    var suppressDoc = function(e) {
      if (e.target !== input) { e.stopImmediatePropagation(); }
    };
    var suppressWin = function(e) {
      e.stopImmediatePropagation();
    };
    var docEvents = ['mousedown', 'mouseup', 'pointerdown', 'pointerup', 'click', 'touchend'];
    var winEvents = ['scroll', 'resize'];
    docEvents.forEach(function(evt) {
      document.addEventListener(evt, suppressDoc, true);
    });
    winEvents.forEach(function(evt) {
      window.addEventListener(evt, suppressWin, true);
    });

    setTimeout(function() {
      trapFocus(container, input);
      /* Keep scroll/resize suppressed longer to cover virtual keyboard */
      setTimeout(function() {
        docEvents.forEach(function(evt) {
          document.removeEventListener(evt, suppressDoc, true);
        });
        winEvents.forEach(function(evt) {
          window.removeEventListener(evt, suppressWin, true);
        });
      }, 500);
    }, 300);
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }
}

customElements.define('details-modal', DetailsModal);
